import { FETCH_DATA_GETCATEGORYLIST1_CAT } from "../ActionType/actionTypes";
import axios from "axios";
import base64Sign from "../../function/base64Sign";
import encryptData from "../../function/encryptData";
import { getToken } from "../../utils/setSessionUser";
import {BaseURL} from '../../function/helpers'
import { isLoadingGetCatList1 } from "./Loading/isLoadingGetCatList1Actions";

export const fetchGetCategoryList1 = (params, url) => {
    return( dispatch ) => {
        const param = encryptData(params)
        const signature = base64Sign(url);
        const access_token = getToken()
        const headers = 
        {
        'Content-Type':'application/json',
        'sign' : signature,
        'access_token' : access_token
        }
        axios.post(BaseURL + url,
            {data: param},
            {headers : headers}
        )
            .then( data => {
                dispatch({
                    type: FETCH_DATA_GETCATEGORYLIST1_CAT,
                    payload: {
                        getCategoryList1: data.data.response_data.results
                    }
                })
                dispatch(isLoadingGetCatList1(false))
            } )
            .catch(error => {
                console.log(error);
            })
    }
}